/**
 * Welche Anmeldewege diese Instanz anbietet, dreiwertig gelesen (Regel aus
 * dem Portal, cloud-v2 `lib/authAnbieter.ts`):
 *
 *   Feld fehlt   → ältere auth-api, sie sagt nichts: Bestand (Google).
 *   `[]`         → ausdrücklich keiner eingerichtet.
 *   `["google"]` → genau dieser eine.
 *
 * Abwesenheit von Auskunft ist keine Auskunft über Abwesenheit.
 */

/** Was ohne Auskunft gilt: der heutige Zustand. */
export const BESTAND: readonly string[] = ['google']

/** Erlaubte Anbieterkennung: eng und positiv gefasst, sie wandert in Pfade. */
const KENNUNG = /^[a-z][a-z0-9_-]{0,31}$/

/** Anbieter, für die wir eine Marke führen dürfen. */
export const MARKEN: Readonly<Record<string, { titel: string; name: string }>> = {
  google: { titel: 'Sign in with Google', name: 'Google' },
  // Microsofts Markenregel schreibt Wortlaut und Zeichen vor.
  microsoft: { titel: 'Sign in with Microsoft', name: 'Microsoft' },
}

/** Die gemeldete Liste, oder `undefined`, wenn die Instanz nichts dazu sagt. */
export function anbieterAusVertrag(roh: unknown): string[] | undefined {
  if (!Array.isArray(roh)) return undefined
  return roh
    .filter((v): v is string => typeof v === 'string')
    .map((v) => v.trim().toLowerCase())
    .filter((v) => KENNUNG.test(v))
}

/** Was der Anmeldeschirm zeigt. `undefined` → Bestand, `[]` → nichts. */
export function sichtbareAnbieter(gemeldet: readonly string[] | undefined): string[] {
  if (gemeldet === undefined) return [...BESTAND]
  return [...new Set(gemeldet)]
}

/** Der Anzeigetext; ein unbekannter Anbieter wird gezeigt, nicht verschluckt. */
export function titelFuer(id: string): string {
  return MARKEN[id]?.titel ?? `Anmelden mit ${id.charAt(0).toUpperCase()}${id.slice(1)}`
}

/** Der bloße Name, für Fließtext. */
export function nameFuer(id: string): string {
  return MARKEN[id]?.name ?? `${id.charAt(0).toUpperCase()}${id.slice(1)}`
}
